<template>
  <div>
    <div v-if="property_data.type === 1" class="layout-box-1">
      <div
        class="box-style-1"
        v-for="(item, index) in showData"
        @click="jump(item.id)"
        :style="
          `background: linear-gradient(90deg, ${item_bg[0]}, ${item_bg[1]});`
        "
      >
        <img class="card-image" fit="contain" :src="item.img_url" />
        <div class="card-content">
          <div class="card-keyword">
            <img
              class="card-keyword-img"
              src="https://mktv-in-cdn.mockuai.com/16405946889677328.png"
              alt="."
            />{{ item.keyword }}
          </div>
          <div class="card-item-title ellipsis">
            {{ item.title }}
          </div>
          <div class="price-box">
            <div class="price-item left">活动价：{{ item.price }}</div>
            <div class="price-item right">佣金率：{{ item.commission }}%</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="property_data.type === 2" class="layout-box-2">
      <div
        class="box-style-2"
        v-for="(item, index) in showData"
        @click="jump(item.id)"
        :style="
          `background: linear-gradient(180deg, ${item_bg[0]}, ${item_bg[1]});`
        "
      >
        <div class="card-top">
          <img class="card-image" fit="contain" :src="item.img_url" />
          <div class="card-keyword">
            <img
              class="card-keyword-img"
              src="https://mktv-in-cdn.mockuai.com/16405946889677328.png"
              alt="."
            />{{ item.keyword }}
          </div>
        </div>
        <div class="card-content">
          <div class="card-item-title ellipsis">
            {{ item.title }}
          </div>
          <div class="price-box">
            <div class="price-item">
              活动价：<span>¥{{ item.price }}</span>
            </div>
            <div class="price-item">
              佣金率：<span>{{ item.commission }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-active-special",
  props: ["config", "isEditorStatus", "pageData"],
  data() {
    return {};
  },
  computed: {
    app_type() {
      return this.pageData.app_type || "seller";
    },
    showData() {
      if (this.listData.length) {
        return this.listData;
      }
      return this.notData;
    },
    notData() {
      const obj = {
        img_url: "https://mktv-in-cdn.mockuai.com/16397202064747389.png",
        title:
          "蔬小简综合7+谷物优D型片蔬小简综合7+谷物优D型片优D型片蔬小简综合7+谷物优D型片",
        price: 782.33,
        commission: "43.44",
        keyword: "全网爆款",
        id: 8017434,
      };
      if (this.property_data.type === 2) {
        return [obj, obj, obj];
      } else {
        return [obj];
      }
    },
    item_bg() {
      const bg = this.property_data.item_bg;
      if (!Array.isArray(bg)) {
        return [];
      }
      return bg;
    },
    listData() {
      if (this.property_data.list && this.property_data.list.length) {
        return this.property_data.list;
      }
      return [];
    },
    property_data() {
      return this.config.property_data;
    },
  },
  methods: {
    jump(id) {
      if (this.isEditorStatus) {
        return;
      }
      redirectURL(String(id), this.app_type);
    },
  },
};
</script>

<style lang="scss" scoped>
.box-style-1 {
  display: flex;
  background: #ffe4da;
  margin: 0 10px 5px;
  border-radius: 10px;
  padding: 8px 10px;
  .card-content {
    flex: 1;
    margin-left: 15px;
  }
  .card-image {
    display: block;
    width: 93px;
    height: 93px;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 5px;
  }
  .card-keyword {
    width: 94px;
    margin-top: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 19px;
    line-height: 19px;
    border-radius: 19px;
    background: linear-gradient(90deg, #f34814, #ff7521);
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
  .card-keyword-img {
    width: 9px;
    margin-right: 6px;
  }
  .card-item-title {
    font-size: 1.4rem;
    line-height: 1.5;
    color: #333;
    text-align: left;
    font-weight: 400;
    margin-top: 0.6rem;
    margin-bottom: 1.2rem;
  }
  .price-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    border: 1px solid #f76a25;
    border-radius: 5px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    overflow: hidden;
    .price-item {
      flex: 1;
      text-align: center;
      font-weight: bold;
    }
    .left {
      color: #fff;
      background: linear-gradient(90deg, #f1390c 0%, #ff970f 100%);
    }
    .right {
      color: #eb3700;
      background: #ffeed0;
    }
  }
}

.layout-box-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  flex-wrap: wrap;
  .box-style-2 {
    width: 32%;
    text-align: center;
    margin-bottom: 5px;
    background: #ffe4da;
    border-radius: 10px;
  }
  .card-top {
    position: relative;
    .card-image {
      display: block;
      margin: 8px auto 0;
      width: 93px;
      height: 93px;
      background: #ffffff;
      border-radius: 5px;
    }
    .card-keyword {
      position: absolute;
      bottom: 0;
      left: 9px;
      width: calc(100% - 18px);
      margin-top: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 19px;
      line-height: 19px;
      background: linear-gradient(90deg, #f34814, #ff7521);
      font-size: 12px;
      color: #fff;
      font-weight: bold;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .card-keyword-img {
        width: 9px;
        margin-right: 6px;
      }
    }
  }
  .card-item-title {
    font-size: 1.4rem;
    line-height: 1.5;
    color: #333;
    text-align: left;
    font-weight: 400;
    margin-top: 0.6rem;
    margin-bottom: 0.4rem;
  }
  .card-content {
    margin: 0 9px;
  }
  .price-box {
    font-size: 12px;
    line-height: 16px;
    padding-bottom: 6px;
    .price-item {
      color: #f13a0d;
      text-align: left;
      span {
        font-weight: bold;
      }
    }
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  white-space: normal;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
</style>
